const amountFormat = (amount: number): string => {
  return "₹" + (Math.floor(amount * 100) / 100).toLocaleString("hi-in");
};

export { amountFormat };
